
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3d2EW", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $4550e48693be1fb4$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "EllipsisDropdownComponent", () => $4550e48693be1fb4$export$82d507aca0e648e3);
/* EllipsisDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $5izcQ = parcelRequire("5izcQ");

var $ljm2R = parcelRequire("ljm2R");

var $k0pnk = parcelRequire("k0pnk");

var $5fMeR = parcelRequire("5fMeR");

var $3mVfX = parcelRequire("3mVfX");

var $bbp3G = parcelRequire("bbp3G");

var $6ld6a = parcelRequire("6ld6a");

var $dZ4NH = parcelRequire("dZ4NH");

var $l3C2L = parcelRequire("l3C2L");

var $v1jQ6 = parcelRequire("v1jQ6");

var $hp2SH = parcelRequire("hp2SH");
var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $flE5X = parcelRequire("flE5X");

var $5ZqQS = parcelRequire("5ZqQS");

var $b66o6 = parcelRequire("b66o6");

var $ayQVU = parcelRequire("ayQVU");

var $kqvQA = parcelRequire("kqvQA");

var $dPJCf = parcelRequire("dPJCf");

var $jmjWc = parcelRequire("jmjWc");

var $1NBp8 = parcelRequire("1NBp8");

var $BCkug = parcelRequire("BCkug");

var $gTyTP = parcelRequire("gTyTP");

var $2kB0r = parcelRequire("2kB0r");
var $4wEOc = parcelRequire("4wEOc");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $7aRa9 = parcelRequire("7aRa9");

var $iQb1R = parcelRequire("iQb1R");

var $8Bp0j = parcelRequire("8Bp0j");

var $5SlMo = parcelRequire("5SlMo");

var $6DX3n = parcelRequire("6DX3n");

var $b6AjJ = parcelRequire("b6AjJ");
function $4550e48693be1fb4$var$_defineProperty(e, r, t) {
    return (r = $4550e48693be1fb4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4550e48693be1fb4$var$_toPropertyKey(t) {
    var i = $4550e48693be1fb4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4550e48693be1fb4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4550e48693be1fb4$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    preview: {
        id: "editor-ellipsis-dropdown.preview",
        defaultMessage: "Preview"
    },
    templateDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates"
    },
    addLabels: {
        id: "editor-ellipsis-dropdown.open.ellipsis.edit.labels",
        defaultMessage: "Add labels"
    },
    deleteUnpublishedPage: {
        id: "editor-ellipsis-dropdown.open.ellipsis.page.delete",
        defaultMessage: "Delete unpublished page"
    },
    deleteUnpublishedBlogpost: {
        id: "editor-ellipsis-dropdown.open.ellipsis.blogpost.delete",
        defaultMessage: "Delete unpublished blog post"
    },
    revert: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert",
        defaultMessage: "Revert to previous version"
    },
    updateWithoutNotifying: {
        id: "editor-ellipsis-dropdown.open.ellipsis.update.without.notify",
        defaultMessage: "Update without notifying watchers"
    },
    openTemplateBrowser: {
        id: "editor-ellipsis-dropdown.open.template.browser",
        defaultMessage: "Open template browser"
    },
    revertEditor: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert.editor",
        defaultMessage: "Revert to legacy editor"
    },
    undo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.redo",
        defaultMessage: "Redo"
    },
    findReplace: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.find.replace",
        defaultMessage: "Find and replace"
    }
});

const $4550e48693be1fb4$var$LivePagesExpandedEapConversionSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n_f6X",
    name: "LivePagesExpandedEapConversionSpotlightLoader",
    loader: async ()=>(await (parcelRequire("2bY1t"))).LivePagesExpandedEapConversionSpotlight
});
const $4550e48693be1fb4$var$noop = ()=>{}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4550e48693be1fb4$var$MenuItemContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $4550e48693be1fb4$var$previewPage = (createAnalyticsEvent, onPreviewClicked, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'previewPage',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onPreviewClicked(false);
};
const $4550e48693be1fb4$var$publishWithoutNotify = (createAnalyticsEvent, onClickPublish, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'publishWithoutNotifyFromOverflow',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onClickPublish({
        suppressNotifyWatchers: true
    })();
};
class $4550e48693be1fb4$var$EllipsisDropdownClass extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        this.setEditorProperty();
    }
    /**
   * Menu items are pushed into the 'items' list which is used to create the '•••' menu
   * (aka more aka ellipsis aka meatball) for editor pages
   */ _getItems(dialogs) {
        const { addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems, contentType: contentType, isDisabled: isDisabled, isUnpublishedDraft: isUnpublishedDraft, showRevertDialog: showRevertDialog, spaceKey: spaceKey, contentId: contentId, isContentCreationPanelShown: isContentCreationPanelShown, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickPublish: onClickPublish, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onPreviewClicked: onPreviewClicked, createAnalyticsEvent: createAnalyticsEvent, isImportDisabled: isImportDisabled, push: push, saveDraft: saveDraft, switchToLivePage: switchToLivePage, showCommentsPanel: showCommentsPanel, hasEditPermission: hasEditPermission, editorActions: editorActions } = this.props;
        if (this.state.isMenuOpen) createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: 'ellipsisDropdownForMoreItems'
            }
        }).fire();
         // Don't want to trigger exposures when users open the ellipsis dropdown we are
        // just disabling an item that is not required for the experiment
        // The exposure will happen when the user converts a page instead
        const [onEditConvertExp] = (0, $6mKj3.UNSAFE_noExposureExp)('platform_editor_on_edit_convert');
        const addPreviewMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "preview",
                onClick: ()=>{
                    $4550e48693be1fb4$var$previewPage(createAnalyticsEvent, onPreviewClicked, contentId, contentType);
                },
                elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    style: {
                        color: "var(--ds-icon-subtle, #626F86)"
                    }
                }, (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).PREVIEW))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.preview)));
        };
        const showViewChangesDialog = ()=>dialogs.showDialog((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId
            });
        const addViewChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "view-changes",
                onClick: this.saveDraftAnd(showViewChangesDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).viewChanges)));
        };
        const addTemplateBrowserMenuItem = (menuItems)=>{
            const label = isImportDisabled ? $4550e48693be1fb4$export$a7357cdd1f0b0168.templateDocs : (0, $6DX3n.i18n).templateImportDocs;
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "open-template-browser",
                onClick: onClickOpenContentCreationPanel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), label)));
        };
        const addClassifyContentMenuItem = (menuItems)=>{
            if (this.props.isClassificationEnabled) menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), null));
        };
        const addEditLabelsMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k0pnk.EditLabelDropdownItem), {
                contentId: contentId || '',
                spaceKey: spaceKey,
                dialogs: dialogs
            }));
        };
        const addMovePageMenuItem = (menuItems, movePageContentId, movePageSpaceKey)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $v1jQ6.EditorMovePageButtonLoader), {
                contentId: movePageContentId,
                spaceKey: movePageSpaceKey,
                appearance: "dropdownItem",
                analyticsSource: "EllipsisDropdownComponent",
                key: "move-page-button",
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                isUnpublishedDraft: !!isUnpublishedDraft
            }));
        };
        const addResolvedCommentsMenuItem = (menuItems, contentId, spaceKey)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "resolved-comments",
                onClick: ()=>{
                    if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).RESOLVED
                        });
                        return;
                    }
                    dialogs.showDialog((0, $dZ4NH.ResolvedInlineCommentsDialogLoader), {
                        spaceKey: spaceKey,
                        contentId: contentId,
                        context: 'editor'
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$MenuItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).resolvedComments), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dZ4NH.ResolvedInlineCommentsCounterLoader), {
                contentId: contentId
            }))));
        };
        const addDeleteChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "delete-changes",
                onClick: this.saveDraftAnd(showRevertDialog)
            }, isUnpublishedDraft && contentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedPage) : null, isUnpublishedDraft && contentType !== 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedBlogpost) : null, !isUnpublishedDraft ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revert) : null));
        };
        const addSwitchToLiveEditMenuItem = ({ menuItems: menuItemsArg })=>{
            if (this.props.isLivePagesEnabled && contentType === 'page') {
                const switchToLiveEditWebItem = this.props.webItems?.find((item)=>item.id === 'action-switch-to-live-edit');
                if (!switchToLiveEditWebItem) return;
                menuItemsArg.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                    key: "switch-to-live-edit",
                    onClick: switchToLivePage
                }, switchToLiveEditWebItem.label));
            }
        };
        const addPublishGroupMenuItems = (menuItems)=>{
            const publishGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT) && contentId) {
                if (!isUnpublishedDraft) addSwitchToLiveEditMenuItem({
                    menuItems: publishGroupItems
                });
                else if (saveDraft && (0, $9wGTI.fg)('confluence_live_pages_switch_draft_to_live_page')) addSwitchToLiveEditMenuItem({
                    menuItems: publishGroupItems
                });
            }
            if (!isUnpublishedDraft) this.isAllowed((0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY) && publishGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "publish-without-notify",
                isDisabled: isDisabled,
                onClick: ()=>{
                    $4550e48693be1fb4$var$publishWithoutNotify(createAnalyticsEvent, onClickPublish, contentId, contentType);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.updateWithoutNotifying)));
            publishGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "publish-group-items",
                key: "publish-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), null, publishGroupItems)));
            return publishGroupItems.length;
        };
        const addOtherGroupMenuItems = (menuItems)=>{
            const otherGroupItems = [];
            this.isAllowed((0, $iQb1R.Buttons).PREVIEW) && addPreviewMenuItem(otherGroupItems);
            if (!isUnpublishedDraft && this.isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES)) addViewChangesMenuItem(otherGroupItems);
             // Show option to expose the page template menu that pops out from the side
            if (shouldShowOpenContentCreationMenuItem && this.isAllowed((0, $iQb1R.Buttons).TEMPLATE_BROWSER)) addTemplateBrowserMenuItem(otherGroupItems);
            if (contentId && spaceKey) {
                this.isAllowed((0, $iQb1R.Buttons).CLASSIFY_CONTENT) && addClassifyContentMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).EDIT_LABELS) && addEditLabelsMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).MOVE_PAGE) && addMovePageMenuItem(otherGroupItems, contentId, spaceKey);
                this.isAllowed((0, $iQb1R.Buttons).RESOLVED_COMMENTS) && addResolvedCommentsMenuItem(otherGroupItems, contentId, spaceKey);
            } // Empty title needed to maintain blank line above group
            otherGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "other-group-items",
                key: "other-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, otherGroupItems)));
        };
        const addEditorActionsGroupMenuItems = (menuItems)=>{
            const editorActionsGroupItems = [];
            const isAllowed = (contentType === 'page' || contentType === 'blogpost') && hasEditPermission;
            if (!isAllowed || !editorActions) return;
            const { canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = editorActions;
            if (!!editorUndo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-undo",
                isDisabled: !editorCanUndo,
                onClick: ()=>{
                    editorUndo?.();
                },
                elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    style: {
                        color: "var(--ds-icon-subtle, #626F86)"
                    }
                }, (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).UNDO))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.undo)));
            if (!!editorRedo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-redo",
                isDisabled: !editorCanRedo,
                onClick: ()=>{
                    editorRedo?.();
                },
                elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    style: {
                        color: "var(--ds-icon-subtle, #626F86)"
                    }
                }, (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).REDO))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.redo)));
            if (!!editorActivateFindReplace) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-find-replace",
                onClick: ()=>{
                    editorActivateFindReplace?.();
                },
                elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                    style: {
                        color: "var(--ds-icon-subtle, #626F86)"
                    }
                }, (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).FIND_REPLACE))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.findReplace)));
            editorActionsGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "editor-actions-group-items",
                key: "editor-actions-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, editorActionsGroupItems)));
        };
        const showRevertEditorDialog = ()=>{
            dialogs.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $8Bp0j.onClickPageRevert)(push, contentType, spaceKey, contentId)
            });
        };
        const addRevertToLegacyEditor = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "revert-editor",
                onClick: this.saveDraftAnd(showRevertEditorDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revertEditor)));
        };
        const addDiscardGroupMenuItems = (menuItems)=>{
            const discardGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).DELETE_DRAFT)) {
                addDeleteChangesMenuItem(discardGroupItems);
                this.state.isPageAutoconverted && !onEditConvertExp.get('isEnabled', false) && addRevertToLegacyEditor(discardGroupItems);
            } // Empty title needed to maintain blank line above group
            discardGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "discard-group-items",
                key: "discard-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, discardGroupItems)));
        };
        const shouldShowOpenContentCreationMenuItem = !isContentCreationPanelShown && isUnpublishedDraft && contentType === 'page';
        const menuItems = []; /**
                                            * Menu items are separated into three groups: publish, other and discard
                                            * Use the allowedEllipsisButtons array to filter for buttons needed to be rendered
                                            */ 
        addPublishGroupMenuItems(menuItems);
        addEditorActionsGroupMenuItems(menuItems);
        addOtherGroupMenuItems(menuItems);
        addDiscardGroupMenuItems(menuItems);
        addCompanyHubSettingsGroupMenuItems(menuItems);
        return menuItems;
    }
    render() {
        const { isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState, isLivePagesEnabled: isLivePagesEnabled, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $bbp3G.DialogsStateContainer)
            ]
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isLivePagesEnabled && contentType === 'page' && !isUnpublishedDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$LivePagesExpandedEapConversionSpotlightLoader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "live-pages-expanded-eap-changeboarding-convert-to-live"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "ellipsis-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5SlMo.CommonDropdownMenu), {
                isMenuOpen: this.state.isMenuOpen,
                handleMenuOpenChange: this.handleMenuOpenChange,
                isDisabled: isDisabled,
                tooltipDisabledState: tooltipDisabledState
            }, this._getItems(dialogs))))));
    }
    constructor(...args){
        super(...args);
        $4550e48693be1fb4$var$_defineProperty(this, "context", void 0);
        $4550e48693be1fb4$var$_defineProperty(this, "state", {
            isMenuOpen: this.props.isInitialMenuOpen,
            isPageAutoconverted: false
        }); /**
         * Set editor property state
         * @returns {Promise<void>}
         */ 
        $4550e48693be1fb4$var$_defineProperty(this, "setEditorProperty", async ()=>{
            const { contentId: contentId } = this.props;
            const { data: contentPropertiesData } = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $kqvQA.ContentPropertiesQuery),
                variables: {
                    contentId: contentId
                }
            }).catch((e)=>{
                if ((0, $dIouf.isUnauthorizedError)(e) || (0, $flE5X.containsNoNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: (0, $dIouf.Attribution).BACKBONE
                });
                return {
                    data: null
                };
            });
            if (contentPropertiesData) {
                const { editorProperty: editorProperty } = (0, $ayQVU.getAutoConvertionInfo)(contentPropertiesData?.content?.nodes?.[0]);
                const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
                this.setState({
                    isPageAutoconverted: !editorProperty && !isNewPage
                });
            }
        });
        $4550e48693be1fb4$var$_defineProperty(this, "saveDraftAnd", (afterSaveDraftDispatched)=>()=>{
                if (this.props.saveDraft) this.props.saveDraft();
                afterSaveDraftDispatched();
            }); // when allowed ellipsis buttons is undefined, enable all buttons
        $4550e48693be1fb4$var$_defineProperty(this, "isAllowed", (menuItem)=>this.props.allowedEllipsisButtons?.includes(menuItem) ?? true);
        $4550e48693be1fb4$var$_defineProperty(this, "handleMenuOpenChange", (attrs)=>this.setState({
                isMenuOpen: attrs.isOpen
            }));
    }
}
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "displayName", 'EllipsisDropdown');
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "defaultProps", {
    saveDraft: $4550e48693be1fb4$var$noop,
    isDisabled: false,
    isInitialMenuOpen: false
});
const $4550e48693be1fb4$export$82d507aca0e648e3 = (0, $7aRa9.withFlags)((props)=>{
    const addCompanyHubSettingsGroupMenuItems = (0, $b6AjJ.useCompanyHubSettingsGroupMenuItems)(props);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isEnabled: isClassificationEnabled } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const webItemLocation = (0, $6ld6a.useWebItemLocation)({
        location: 'system.content.action',
        contentId: props.contentId
    });
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)({
        contentId: props.contentId,
        spaceId: props.spaceId,
        isUnpublishedDraft: !!props.isUnpublishedDraft,
        flags: props.flags,
        retrieveEditorTitleAndContent: props.retrieveEditorTitleAndContent,
        saveDraft: props.saveDraft,
        analyticsSource: 'ellipsisDropdownComponent',
        adfOrigin: 'EDITOR',
        onSuccessfulConversion: ()=>{
            // Redirect to the route for the new live page.
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: props.spaceKey,
                contentId: props.contentId
            }));
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$EllipsisDropdownClass, {
        ...props,
        addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems,
        createAnalyticsEvent: createAnalyticsEvent,
        isLivePagesEnabled: isLivePagesFeatureEnabled,
        isClassificationEnabled: isClassificationEnabled,
        push: push,
        webItems: webItemLocation?.webItems || [],
        switchToLivePage: switchToLivePage,
        showCommentsPanel: showCommentsPanel
    });
});

});
parcelRegister("5izcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f788f1551fff696f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $QiYCb = parcelRequire("QiYCb");

var $6cnUO = parcelRequire("6cnUO");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;

});
parcelRegister("QiYCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3edd35791f2369$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dlAOT = parcelRequire("dlAOT");
const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dlAOT))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ref: divRef,
        className: (0, $35pXk.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;

});


parcelRegister("k0pnk", function(module, exports) {

$parcel$export(module.exports, "EditLabelDropdownItem", () => $bb6d2606da8fa2b2$export$207a057b55bce66d);

var $gwFzn = parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $88KVZ = parcelRequire("88KVZ");

var $4vaoM = parcelRequire("4vaoM");
const $bb6d2606da8fa2b2$export$207a057b55bce66d = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>{
    const buttonText = (0, $88KVZ.useLabelsDescriptionText)({
        contentId: contentId
    });
    const showEditLabelDialog = ()=>{
        const dialogProps = {
            contentId: contentId,
            spaceKey: spaceKey,
            source: 'fabricEditor'
        };
        dialogs.showModal((0, $4vaoM.EditLabelDialogLoader), dialogProps);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "edit-labels",
        onClick: showEditLabelDialog
    }, buttonText);
};

});
parcelRegister("88KVZ", function(module, exports) {

$parcel$export(module.exports, "useLabelsDescriptionText", () => $e7b359a64ad828f1$export$45bed9d3e3f6648d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $hp2SH = parcelRequire("hp2SH");

var $eDV4X = parcelRequire("eDV4X");

var $cUIkM = parcelRequire("cUIkM");
const $e7b359a64ad828f1$var$i18n = (0, $2nPZH.defineMessages)({
    edit: {
        id: "labels.modal.title.edit-label",
        defaultMessage: "Edit labels"
    },
    add: {
        id: "labels.modal.title.add-label",
        defaultMessage: "Add labels"
    }
});
const $e7b359a64ad828f1$export$45bed9d3e3f6648d = ({ contentId: contentId, contentType: contentType, labels: labels })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [hasLabels, setHasLabels] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        async function checkHasLabels() {
            if (contentType === (0, $eDV4X.ContentTypes).TEMPLATE) {
                const labelCount = labels?.length || 0;
                setHasLabels(labelCount > 0);
            } else {
                const { data: data } = await apolloClient.query({
                    query: (0, $cUIkM.LabelsCountQuery),
                    variables: {
                        contentId: contentId,
                        status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                    }
                });
                setHasLabels(data?.singleContent?.labels?.count > 0);
            }
        }
        checkHasLabels();
    }, [
        contentId,
        contentType,
        labels
    ]);
    return typeof hasLabels === 'boolean' ? formatMessage(hasLabels ? $e7b359a64ad828f1$var$i18n.edit : $e7b359a64ad828f1$var$i18n.add) : '';
};

});
parcelRegister("eDV4X", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_CONTENT_STATUSES", () => $e24dc53dc88ae3e8$export$3211963609921415);
$parcel$export(module.exports, "ActionTypes", () => $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "INVALID_CHARACTERS", () => $e24dc53dc88ae3e8$export$cac90560d1a4fb86);
$parcel$export(module.exports, "ContentTypes", () => $e24dc53dc88ae3e8$export$b9e669a853ca2f38);
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});

});

parcelRegister("cUIkM", function(module, exports) {

$parcel$export(module.exports, "LabelsCountQuery", () => $865b819f05ce8472$export$83f92c0e89c7ef19);

var $d2LG0 = parcelRequire("d2LG0");
const $865b819f05ce8472$export$83f92c0e89c7ef19 = (0, $d2LG0.default)`query LabelsCountQuery($contentId:ID!$status:[String]){singleContent(id:$contentId status:$status){id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count}}}`;

});


parcelRegister("4vaoM", function(module, exports) {

$parcel$export(module.exports, "EditLabelDialogLoader", () => $a85e440150ad6165$export$761f49b4caa7a581);

var $jmjWc = parcelRequire("jmjWc");

const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("5ttkG"))).EditLabelDialogComponent
});

});
parcelRegister("5ttkG", function(module, exports) {

let $3fc66a0c08497b1b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3fc66a0c08497b1b$var$load("1kb22"),
    $3fc66a0c08497b1b$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});



parcelRegister("6ld6a", function(module, exports) {

$parcel$export(module.exports, "useWebItemLocation", () => $f64809aa9d8f3ca2$export$13a30d244c53e90d);

var $diswb = parcelRequire("diswb");

var $jV49M = parcelRequire("jV49M");

var $jIQq0 = parcelRequire("jIQq0");

var $fjiOd = parcelRequire("fjiOd");

var $62BfR = parcelRequire("62BfR");
const $f64809aa9d8f3ca2$export$13a30d244c53e90d = ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};

});
parcelRegister("jIQq0", function(module, exports) {

var $2RyUS = parcelRequire("2RyUS");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $e5bac997982bd22e$var$uniq(array) {
    return array && array.length ? $2RyUS(array) : [];
}
module.exports = $e5bac997982bd22e$var$uniq;

});

parcelRegister("62BfR", function(module, exports) {

$parcel$export(module.exports, "replaceAtlTokenPlaceholder", () => $d97d2e8640b15cc8$export$87286345b169ae5e);
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}

});


parcelRegister("dZ4NH", function(module, exports) {

$parcel$export(module.exports, "ResolvedInlineCommentsDialogLoader", () => $c85e5a0a8019d662$export$492577bc4a81367b);
$parcel$export(module.exports, "ResolvedInlineCommentsCounterLoader", () => $c85e5a0a8019d662$export$20020b6b9f67a9ec);

var $jmjWc = parcelRequire("jmjWc");

const $c85e5a0a8019d662$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aBZFP",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("r50MK"))).ResolvedInlineCommentsDialog
});

const $c85e5a0a8019d662$export$910771def0791455 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xHM7h",
    name: "ResolvedInlineCommentsQueryRendererLoader",
    loader: async ()=>(await (parcelRequire("do6Wx"))).ResolvedInlineCommentsQueryRenderer
});

const $c85e5a0a8019d662$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a-qcu",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("5WHor"))).ResolvedInlineCommentsCounter
});

});
parcelRegister("r50MK", function(module, exports) {

let $051668f19439e408$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $051668f19439e408$var$load("hOsjc").then(()=>parcelRequire('92Mdh'));

});

parcelRegister("do6Wx", function(module, exports) {

let $0283eaf3b6d858d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0283eaf3b6d858d6$var$load("km34l").then(()=>parcelRequire('hytVp'));

});

parcelRegister("5WHor", function(module, exports) {

let $4544078af29d28e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4544078af29d28e4$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});


parcelRegister("l3C2L", function(module, exports) {

$parcel$export(module.exports, "ViewChangesDialogLoader", () => $ff94b9918380dc5d$export$cc6c027a319af205);

var $jmjWc = parcelRequire("jmjWc");

const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("axySR"))).ViewChangesDialog
});

});
parcelRegister("axySR", function(module, exports) {

let $7ac80bae6dfc6eef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ac80bae6dfc6eef$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});


parcelRegister("v1jQ6", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButtonLoader", () => $163bb5cb9a2af796$export$bb4636d2bf564dee);

var $5RlDR = parcelRequire("5RlDR");
const $163bb5cb9a2af796$export$bb4636d2bf564dee = (0, $5RlDR.EditorMovePageButton);

});
parcelRegister("5RlDR", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButton", () => $34016fb8fb167321$export$65b66e3b59bd4f0);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $dAYOx = parcelRequire("dAYOx");

var $3gadb = parcelRequire("3gadb");

var $4KS7f = parcelRequire("4KS7f");

var $inPa6 = parcelRequire("inPa6");

var $bbp3G = parcelRequire("bbp3G");

var $dIouf = parcelRequire("dIouf");

var $bHd1w = parcelRequire("bHd1w");

var $78wUU = parcelRequire("78wUU");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $fcURH = parcelRequire("fcURH");
const $34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs = ({ spaceKey: spaceKey, contentId: contentId, appearance: appearance = 'dropdownItem', analyticsSource: analyticsSource, dialogs: dialogs, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query EditorMovePageButtonQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id type status operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId
        },
        displayName: 'EditorMovePageButtonQuery'
    });
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (loading) return null;
    const content = data?.content?.nodes?.[0];
    const contentType = content?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const canMoveContent = isUnpublishedDraft || contentType === 'page' || !!operations.find((op)=>op?.targetType === contentType && op?.operation === 'delete');
    const openMoveModal = ()=>{
        if (contentType === 'page') {
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs.showModal((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                isMovingDraftVersion: true,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'page'
                }
            }).fire();
        } else if (contentType === 'blogpost') {
            dialogs.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: true,
                isUnpublishedDraft: isUnpublishedDraft,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'blog'
                }
            }).fire();
        }
    };
    let component;
    // if FF is on we should show move button for both blog and page types and for both publish and unpublish states
    if (canMoveContent || isUnpublishedDraft && contentType === 'page') {
        if (appearance === 'iconButton') {
            const icon = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                className: "icon aui-icon aui-icon-small aui-iconfont-nav-children"
            });
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                tag: "span",
                content: intl.formatMessage((0, $fcURH.i18n).movePageBtnDesc)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                testId: "move-page-icon-button",
                iconBefore: icon,
                appearance: "subtle",
                onClick: openMoveModal
            }));
        } else if (appearance === 'dropdownItem') component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            onClick: openMoveModal,
            testId: "move-page-dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $fcURH.i18n).movePageBtnDesc));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "move-page-button"
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), component);
};
const $34016fb8fb167321$export$65b66e3b59bd4f0 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bbp3G.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs, {
            ...props,
            dialogs: dialogs
        }));
};

});
parcelRegister("bHd1w", function(module, exports) {

$parcel$export(module.exports, "MovePageDialog", () => $4f760397570928c6$export$28f6951b4656036e);

var $jmjWc = parcelRequire("jmjWc");

const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("1lfob"))).MovePageDialog
});

});
parcelRegister("1lfob", function(module, exports) {

let $0fa3b08eae0a92b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0fa3b08eae0a92b5$var$load("fOLlY"),
    $0fa3b08eae0a92b5$var$load("58UdM"),
    $0fa3b08eae0a92b5$var$load("4Qstt"),
    $0fa3b08eae0a92b5$var$load("5odbj"),
    $0fa3b08eae0a92b5$var$load("jZuk8"),
    $0fa3b08eae0a92b5$var$load("hY77v"),
    $0fa3b08eae0a92b5$var$load("7WcBh"),
    $0fa3b08eae0a92b5$var$load("2irg6"),
    $0fa3b08eae0a92b5$var$load("iLLJH"),
    $0fa3b08eae0a92b5$var$load("5zDuS"),
    $0fa3b08eae0a92b5$var$load("2Fobu"),
    $0fa3b08eae0a92b5$var$load("2YKx2"),
    $0fa3b08eae0a92b5$var$load("26IOy"),
    $0fa3b08eae0a92b5$var$load("2nuqm"),
    $0fa3b08eae0a92b5$var$load("8MOue"),
    $0fa3b08eae0a92b5$var$load("i8Lm5"),
    $0fa3b08eae0a92b5$var$load("aqWBW"),
    $0fa3b08eae0a92b5$var$load("U7y88"),
    $0fa3b08eae0a92b5$var$load("fEx3B"),
    $0fa3b08eae0a92b5$var$load("dJQEi"),
    $0fa3b08eae0a92b5$var$load("6qah4"),
    $0fa3b08eae0a92b5$var$load("j4gWN"),
    $0fa3b08eae0a92b5$var$load("hTb35"),
    $0fa3b08eae0a92b5$var$load("87F9B"),
    $0fa3b08eae0a92b5$var$load("aZinD"),
    $0fa3b08eae0a92b5$var$load("hrAMe"),
    $0fa3b08eae0a92b5$var$load("i5Fj1"),
    $0fa3b08eae0a92b5$var$load("c6MKV"),
    $0fa3b08eae0a92b5$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});


parcelRegister("78wUU", function(module, exports) {

$parcel$export(module.exports, "MoveBlogModalLoader", () => $745e4e253bb54f50$export$fbea3c6f057d30b6);

var $jmjWc = parcelRequire("jmjWc");

const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("eF5zb"))).MoveBlogModal
});

});
parcelRegister("eF5zb", function(module, exports) {

let $aac9366434f9c53d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $aac9366434f9c53d$var$load("58UdM"),
    $aac9366434f9c53d$var$load("4Qstt"),
    $aac9366434f9c53d$var$load("5odbj"),
    $aac9366434f9c53d$var$load("jZuk8"),
    $aac9366434f9c53d$var$load("hY77v"),
    $aac9366434f9c53d$var$load("26IOy"),
    $aac9366434f9c53d$var$load("2nuqm"),
    $aac9366434f9c53d$var$load("8MOue"),
    $aac9366434f9c53d$var$load("i8Lm5"),
    $aac9366434f9c53d$var$load("aqWBW"),
    $aac9366434f9c53d$var$load("U7y88"),
    $aac9366434f9c53d$var$load("fEx3B"),
    $aac9366434f9c53d$var$load("dJQEi"),
    $aac9366434f9c53d$var$load("aZinD"),
    $aac9366434f9c53d$var$load("6qah4"),
    $aac9366434f9c53d$var$load("j4gWN"),
    $aac9366434f9c53d$var$load("i5Fj1"),
    $aac9366434f9c53d$var$load("c6MKV"),
    $aac9366434f9c53d$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});


parcelRegister("fcURH", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $0ac47e05aff110d2$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $0ac47e05aff110d2$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    movePageBtnDesc: {
        id: "editor-move-page-button.move.page.description",
        defaultMessage: "Move"
    }
});

});



parcelRegister("b66o6", function(module, exports) {

$parcel$export(module.exports, "RevertEditorDialog", () => $f480656426be1312$export$b62abe642254f319);

var $jmjWc = parcelRequire("jmjWc");

const $f480656426be1312$export$b62abe642254f319 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "O8EvX",
    name: "RevertEditorDialog",
    loader: async ()=>(await (parcelRequire("h0E2Y"))).RevertEditorDialog
});

});
parcelRegister("h0E2Y", function(module, exports) {

let $c6218043233c96db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c6218043233c96db$var$load("23MlT").then(()=>parcelRequire('1yiQ2'));

});


parcelRegister("ayQVU", function(module, exports) {

$parcel$export(module.exports, "getAutoConvertionInfo", () => $0e83f72969672585$export$a53517c120ec9f4);
// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null
    };
}

});

parcelRegister("kqvQA", function(module, exports) {

$parcel$export(module.exports, "ContentPropertiesQuery", () => $65e63a8a734d713c$export$4ea7a3f4ac83fe8b);

var $d2LG0 = parcelRequire("d2LG0");
const $65e63a8a734d713c$export$4ea7a3f4ac83fe8b = (0, $d2LG0.default)`query ContentPropertiesQuery($contentId:ID$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}}}}`;

});

parcelRegister("BCkug", function(module, exports) {

$parcel$export(module.exports, "useSwitchToLivePage", () => $f911f42fbae43711$export$652cb536b0ebabdb);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $8aF6s = parcelRequire("8aF6s");

var $bN5DJ = parcelRequire("bN5DJ");

var $3FmeR = parcelRequire("3FmeR");

var $hEbCl = parcelRequire("hEbCl");
const $f911f42fbae43711$export$652cb536b0ebabdb = (props)=>{
    const { contentId: contentId, spaceId: spaceId, isUnpublishedDraft: isUnpublishedDraft, analyticsSource: analyticsSource, adfOrigin: adfOrigin, onSuccessfulConversion: onSuccessfulConversion, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, saveDraft: saveDraft } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showConvertToLivePageFlag = (0, $hEbCl.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSuccess = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'convertedToLivePage',
                actionSubject: 'page',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        onSuccessfulConversion?.();
        showConvertToLivePageFlag({
            converterWasCurrentUser: true
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        onSuccessfulConversion,
        showConvertToLivePageFlag
    ]);
    return (0, $gwFzn.useCallback)(async ()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchToLiveEdit',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isUnpublishedDraft) showModal((0, $bN5DJ.ConvertToLivePageDialog), {
            contentId: contentId,
            onConfirm: onSuccess,
            adfOrigin: adfOrigin,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
        });
        else {
            // Trigger draft sync before converting. If we don't do this and the user recently updated their draft title then quickly converted the draft, draft sync may not have triggered and we may not identify their title conflict.
            await saveDraft?.();
            (0, $3FmeR.convertDraftToLivePage)({
                contentId: contentId,
                spaceId: spaceId,
                onSuccess: onSuccess,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        showModal,
        onSuccess,
        adfOrigin,
        retrieveEditorTitleAndContent,
        flags,
        saveDraft
    ]);
};

});
parcelRegister("bN5DJ", function(module, exports) {

$parcel$export(module.exports, "ConvertToLivePageDialog", () => $5b509ab565dd40fa$export$13f6b1ebaf0950f0);

var $jmjWc = parcelRequire("jmjWc");

const $5b509ab565dd40fa$export$13f6b1ebaf0950f0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_DPHW",
    name: "ConvertToLivePageDialog",
    loader: async ()=>(await (parcelRequire("hMHHm"))).ConvertToLivePageDialog
});

});
parcelRegister("hMHHm", function(module, exports) {

let $cf28d0f7f2f26d86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cf28d0f7f2f26d86$var$load("RU02s").then(()=>parcelRequire('9Pjdf'));

});


parcelRegister("3FmeR", function(module, exports) {

$parcel$export(module.exports, "convertDraftToLivePage", () => $cb12ca6e6f1d2ae2$export$a4275df84ffd8722);

var $gwFzn = parcelRequire("gwFzn");

var $d2LG0 = parcelRequire("d2LG0");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $hp2SH = parcelRequire("hp2SH");

var $jhwJP = parcelRequire("jhwJP");

var $fyUox = parcelRequire("fyUox");

var $irrTO = parcelRequire("irrTO");

var $9sGCn = parcelRequire("9sGCn");

var $5WpL8 = parcelRequire("5WpL8");

var $6LFAK = parcelRequire("6LFAK");
const $cb12ca6e6f1d2ae2$var$i18nBase = (0, $2nPZH.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title",
        defaultMessage: "Unable to convert draft to live page"
    },
    genericErrorFlagTitle: {
        id: "live-pages-features.converttolivepage.generic-error.title",
        defaultMessage: "An error occurred"
    }
});
const $cb12ca6e6f1d2ae2$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs",
        defaultMessage: "Unable to convert draft to live doc"
    }
});
const $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($cb12ca6e6f1d2ae2$var$i18nBase, $cb12ca6e6f1d2ae2$var$i18nLiveDocs);
const $cb12ca6e6f1d2ae2$var$preloadProperties = async (contentId, spaceId)=>{
    const tasks = [];
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceId,
        fetchPolicy: 'network-only'
    }));
    tasks.push((0, $irrTO.preloadDraftContentAppearance)(contentId, false));
    return Promise.all(tasks);
};
const $cb12ca6e6f1d2ae2$export$a4275df84ffd8722 = async ({ contentId: contentId, spaceId: spaceId = '', onSuccess: onSuccess, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent })=>{
    try {
        const { data: mutationData } = await (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $5WpL8.convertPageToLiveEditMutation),
            variables: {
                contentId: contentId
            },
            update: (cache, { data: data })=>{
                if (data?.convertPageToLiveEditAction?.success) {
                    cache.writeFragment({
                        id: `Content:${contentId}`,
                        fragment: (0, $d2LG0.default)`fragment SubTypeUpdate on Content{subType}`,
                        data: {
                            __typename: 'Content',
                            subType: 'live'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        });
        const result = mutationData?.convertPageToLiveEditAction;
        if (result?.success) {
            await $cb12ca6e6f1d2ae2$var$preloadProperties(contentId, spaceId).catch(()=>{
            // Since its a preload, we don't want show an error flag
            });
            onSuccess();
            return;
        }
        result.errors.forEach(async (error)=>{
            (0, $6LFAK.processError)(error, contentId);
            const flagTitle = error.message === 'Title already exists' ? $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.titleConflictFlagTitle : $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle;
            const flagDescription = (0, $6LFAK.getI18nStringForError)(error.message);
            const flagDescriptionValues = {};
            if (error.message === 'Title already exists') {
                const { title: pageTitle } = await retrieveEditorTitleAndContent();
                flagDescriptionValues.pageTitle = pageTitle || '';
            }
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), flagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                    ...flagDescription,
                    values: flagDescriptionValues
                }),
                isAutoDismiss: false
            });
        });
    } catch (error) {
        (0, $6LFAK.processError)(error, contentId);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6LFAK.i18n).unknownError),
            isAutoDismiss: false
        });
    }
};
const $cb12ca6e6f1d2ae2$export$5c2d46edf58b6daa = $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168;

});
parcelRegister("fyUox", function(module, exports) {

$parcel$export(module.exports, "preloadPageTitleContentProperties", () => $bf604cb6b214d1ef$export$a65164d365713802);

var $dYU3e = parcelRequire("dYU3e");

var $2eBB6 = parcelRequire("2eBB6");
const $bf604cb6b214d1ef$var$preloadHomepageId = (spaceKey)=>(0, $dYU3e.query)({
        query: (0, $2eBB6.HomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $2eBB6.TitleContentPropertyQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) promises.push($bf604cb6b214d1ef$var$preloadHomepageId(spaceKey).then((res)=>{
        const homepageId = res?.data?.space?.homepage?.id;
        if (homepageId) return $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId);
    }));
    else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return Promise.all(promises);
};

});

parcelRegister("5WpL8", function(module, exports) {

$parcel$export(module.exports, "convertPageToLiveEditMutation", () => $09ce99652710d2ad$export$86ef618dec362c86);

var $d2LG0 = parcelRequire("d2LG0");
const $09ce99652710d2ad$export$86ef618dec362c86 = (0, $d2LG0.default)`mutation ConvertPageToLiveEdit($contentId:ID!){convertPageToLiveEditAction(input:{contentId:$contentId}){success errors{message}}}`;

});

parcelRegister("6LFAK", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $49d66c83bc63de25$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "getI18nStringForError", () => $49d66c83bc63de25$export$55d2d97fdb72d6e6);
$parcel$export(module.exports, "processError", () => $49d66c83bc63de25$export$83457a6c00af4df7);

var $2nPZH = parcelRequire("2nPZH");

var $aTqya = parcelRequire("aTqya");

var $jhwJP = parcelRequire("jhwJP");

var $dIouf = parcelRequire("dIouf");

var $5ZqQS = parcelRequire("5ZqQS");
var $fJlJm = parcelRequire("fJlJm");

var $flE5X = parcelRequire("flE5X");

var $7Sm4c = parcelRequire("7Sm4c");
const $49d66c83bc63de25$var$i18nBase = (0, $2nPZH.defineMessages)({
    unknownError: {
        id: "live-pages-features.converttolivepage.modal.error.unknown",
        defaultMessage: "An error occurred. Please try again."
    },
    serverException: {
        id: "live-pages-features.converttolivepage.modal.error.serverException",
        defaultMessage: "An unexpected error occurred. Please try again later."
    },
    pageNotFound: {
        id: "live-pages-features.converttolivepage.modal.error.pageNotFound",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "The page you\u2019re trying to edit doesn\u2018t exist."
    },
    contentServiceException: {
        id: "live-pages-features.converttolivepage.modal.error.contentServiceException",
        defaultMessage: "The requested content is not available."
    },
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive",
        defaultMessage: "This page has already been switched to a live page."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError",
        defaultMessage: "This page can\u2019t be switched to a live page due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions",
        defaultMessage: "You don\u2019t have the necessary permissions to switch this to a live page."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    viewScreenTitleConflict: {
        id: "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict",
        defaultMessage: "There\u2019s already content with this page\u2019s updated title in the space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs",
        defaultMessage: "This page has already been converted to a live doc."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs",
        defaultMessage: "This page can\u2019t be converted to a live doc due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs",
        defaultMessage: "You don\u2019t have the necessary permissions to convert this to a live doc."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($49d66c83bc63de25$var$i18nBase, $49d66c83bc63de25$var$i18nLiveDocs);
const $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY = {
    serverException: 'Some server exception',
    pageNotFound: 'Page not found with provided id',
    contentServiceException: 'Content service exception',
    pageAlreadyLive: 'Page subtype is already set to live',
    legacyPageConversionError: 'Legacy page cannot be converted to live edit',
    noEditPermissions: 'Page cannot be converted without edit permissions',
    draftTitleConflict: 'Title already exists'
};
const $49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE = Object.entries($49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY).reduce((acc, [key, value])=>({
        ...acc,
        [value]: key
    }), {});
const $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES = [
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.draftTitleConflict,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageAlreadyLive,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.noEditPermissions,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageNotFound
];
const $49d66c83bc63de25$export$55d2d97fdb72d6e6 = (errorMessage)=>{
    return $49d66c83bc63de25$export$a7357cdd1f0b0168[$49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE[errorMessage]] || $49d66c83bc63de25$export$a7357cdd1f0b0168.unknownError;
};
const $49d66c83bc63de25$export$ad03839ff2e809af = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $dIouf.Attribution).PAGE_MODES
    });
};
const $49d66c83bc63de25$export$83457a6c00af4df7 = (error, contentId)=>{
    let normalizedError;
    if (error instanceof Error || error instanceof (0, $aTqya.ApolloError)) normalizedError = error;
    else {
        // NOTE: Mutation errors from conversion have a null prototype, causing some below checks to throw an error because `hasOwnProperty` doesn't exist.
        //       Wrapping in a new Error retains original context and ensures the error contains `hasOwnProperty`, so we can handle the errors we're passed without issue.
        normalizedError = new Error(error?.message || 'Unknown error');
        if (error?.__typename) normalizedError.name = error?.__typename;
    }
    const isHandledConversionError = $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES.includes(normalizedError.message);
    if ((0, $dIouf.isUnauthorizedError)(normalizedError) || (0, $flE5X.containsNoNetworkError)(normalizedError) || isHandledConversionError) {
        (0, $7Sm4c.markErrorAsHandled)(normalizedError);
        return {
            isHandled: true
        };
    } else {
        $49d66c83bc63de25$export$ad03839ff2e809af(normalizedError, contentId);
        return {
            isHandled: false
        };
    }
};

});


parcelRegister("hEbCl", function(module, exports) {

$parcel$export(module.exports, "useShowConvertToLivePageFlag", () => $c965ee8ccbf49856$export$cb5a789d90de377);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $jhwJP = parcelRequire("jhwJP");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $de2j9 = parcelRequire("de2j9");

var $ep3mz = parcelRequire("ep3mz");
const $c965ee8ccbf49856$var$i18nBase = (0, $2nPZH.defineMessages)({
    flagTitle: {
        id: "live-pages-features.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "live-pages-features.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "live-pages-features.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "live-pages-features.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "live-pages-features.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $c965ee8ccbf49856$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    flagTitle: {
        id: "live-pages-features.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "live-pages-features.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "live-pages-features.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "live-pages-features.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $c965ee8ccbf49856$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c965ee8ccbf49856$var$i18nBase, $c965ee8ccbf49856$var$i18nLiveDocs);
const $c965ee8ccbf49856$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $c965ee8ccbf49856$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $c965ee8ccbf49856$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $dBxQj.default)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $gwFzn.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $gwFzn.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($c965ee8ccbf49856$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($c965ee8ccbf49856$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($c965ee8ccbf49856$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($c965ee8ccbf49856$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($c965ee8ccbf49856$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($c965ee8ccbf49856$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $c965ee8ccbf49856$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};

});


parcelRegister("2kB0r", function(module, exports) {

$parcel$export(module.exports, "EllipsisClassificationMenuItem", () => $6e3699f987da9ca3$export$805becd8a04238d2);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");

var $40pD8 = parcelRequire("40pD8");
const $6e3699f987da9ca3$var$messages = (0, $2nPZH.defineMessages)({
    classifyContent: {
        id: "data-classification.ellipsis-classification-menu-item.classify-content",
        defaultMessage: "Classify content"
    }
});
const $6e3699f987da9ca3$export$805becd8a04238d2 = ({ elemBefore: elemBefore })=>{
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "classify-content",
        onClick: onClick,
        elemBefore: elemBefore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $6e3699f987da9ca3$var$messages.classifyContent));
};

});
parcelRegister("40pD8", function(module, exports) {

$parcel$export(module.exports, "ClassificationModalContextProvider", () => $512bc11813ea6463$export$dd63fef46bf243c2);
$parcel$export(module.exports, "useClassificationModalContext", () => $512bc11813ea6463$export$3e27c86e4ac00950);
$parcel$export(module.exports, "useClassificationModalDispatchContext", () => $512bc11813ea6463$export$6c62639a7ca504f5);

var $gwFzn = parcelRequire("gwFzn");
const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $gwFzn.useState)(false);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $gwFzn.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = ()=>{
    return (0, $gwFzn.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = ()=>{
    return (0, $gwFzn.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};

});


parcelRegister("4wEOc", function(module, exports) {

$parcel$export(module.exports, "useIsDataClassificationEnabledForOrg", () => $17b0e005176b05e7$export$2e6840e38da4c328);

var $j1Ss3 = parcelRequire("j1Ss3");

var $hqBgv = parcelRequire("hqBgv");
const $17b0e005176b05e7$export$2e6840e38da4c328 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $hqBgv.DataClassificationEnabledQuery), {
        context: {
            single: true
        }
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};

});
parcelRegister("hqBgv", function(module, exports) {

$parcel$export(module.exports, "DataClassificationEnabledQuery", () => $9cb6dff7c1cbf98f$export$256961ed8e8e1e49);

var $d2LG0 = parcelRequire("d2LG0");
const $9cb6dff7c1cbf98f$export$256961ed8e8e1e49 = (0, $d2LG0.default)`query DataClassificationEnabledQuery{isDataClassificationEnabled}`;

});


parcelRegister("8Bp0j", function(module, exports) {

$parcel$export(module.exports, "onClickPageRevert", () => $0356e29d5cbfb982$export$bd41ea3025fc88df);
const $0356e29d5cbfb982$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId)=>{
    if (contentType && contentId) {
        const isBlogPost = contentType === 'blogpost';
        const url = isBlogPost ? `${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}` : `${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`;
        push(url);
    }
};

});

parcelRegister("5SlMo", function(module, exports) {

$parcel$export(module.exports, "CommonDropdownMenu", () => $79e94f3a61d46da4$export$6885a1ceb54a0bf4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $9VJDA = parcelRequire("9VJDA");

var $3gadb = parcelRequire("3gadb");
const $79e94f3a61d46da4$var$i18n = (0, $2nPZH.defineMessages)({
    moreActions: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip",
        defaultMessage: "More actions"
    }
});
const $79e94f3a61d46da4$export$6885a1ceb54a0bf4 = ({ isMenuOpen: isMenuOpen, handleMenuOpenChange: handleMenuOpenChange, children: children, testId: testId = 'ellipsis-dropdown-menu', isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const disabledTooltipI18nObject = {
        id: tooltipDisabledState
    };
    const disabledTooltipText = tooltipDisabledState ? formatMessage(disabledTooltipI18nObject) : '';
    const tooltip = isDisabled ? disabledTooltipText : formatMessage($79e94f3a61d46da4$var$i18n.moreActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: isMenuOpen ? '' : tooltip,
        position: "bottom",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "ellipsis-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        testId: testId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
                ...props,
                label: formatMessage($79e94f3a61d46da4$var$i18n.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                isDisabled: isDisabled,
                appearance: "subtle"
            }),
        appearance: "tall",
        isOpen: isMenuOpen,
        onOpenChange: handleMenuOpenChange
    }, children)));
};

});

parcelRegister("6DX3n", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a4d3843be7f7fab1$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $a4d3843be7f7fab1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    viewChanges: {
        id: "editor-ellipsis-dropdown.open.ellipsis.view.changes",
        defaultMessage: "View changes"
    },
    resolvedComments: {
        id: "editor-ellipsis-dropdown.open.ellipsis.resolved.comments",
        defaultMessage: "Resolved comments"
    },
    templateImportDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import",
        defaultMessage: "Templates & import doc"
    },
    more: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more",
        defaultMessage: "More"
    }
});

});

parcelRegister("b6AjJ", function(module, exports) {

$parcel$export(module.exports, "useCompanyHubSettingsGroupMenuItems", () => $d12f14fcd1ce1fef$export$6509bc85392c811e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $6fjxX = parcelRequire("6fjxX");

var $jq4tF = parcelRequire("jq4tF");
var $lOeVN = parcelRequire("lOeVN");

var $cEgMD = parcelRequire("cEgMD");
const $d12f14fcd1ce1fef$var$i18n = (0, $2nPZH.defineMessages)({
    shareFeedback: {
        id: "editor-ellipsis-dropdown.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    }
});
function $d12f14fcd1ce1fef$export$6509bc85392c811e({ spaceKey: spaceKey }) {
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openFeedbackCollector = (0, $lOeVN.useFeedbackCollector)({
        source: 'hubEditorEllipsisDropdown',
        type: (0, $jq4tF.FeedbackType).COMPANY_HUB
    });
    return (0, $gwFzn.useCallback)((menuItems)=>{
        if (!isCompanyHub) return;
        menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
            hasSeparator: menuItems.length >= 1,
            key: "company-hub-settings-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: "share-feedback",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                label: ""
            }),
            onClick: openFeedbackCollector
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d12f14fcd1ce1fef$var$i18n.shareFeedback))));
    }, [
        isCompanyHub,
        openFeedbackCollector
    ]);
}

});
parcelRegister("6fjxX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c34e576a5d6e3c$var$_react = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $48c34e576a5d6e3c$var$_baseNew = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $48c34e576a5d6e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48c34e576a5d6e3c$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $48c34e576a5d6e3c$var$_react.default.createElement($48c34e576a5d6e3c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$48c34e576a5d6e3c$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $48c34e576a5d6e3c$var$_default = module.exports.default = $48c34e576a5d6e3c$var$MegaphoneIcon;

});

parcelRegister("jq4tF", function(module, exports) {

$parcel$export(module.exports, "FeedbackType", () => $edeacd0030bcf485$export$d4c0482bf980ef26);
var $edeacd0030bcf485$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    return FeedbackType;
}({});

});

parcelRegister("lOeVN", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $926167cc1656a619$export$4be696be8a3bff13);

var $gwFzn = parcelRequire("gwFzn");

var $8aF6s = parcelRequire("8aF6s");

var $jmjWc = parcelRequire("jmjWc");
function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $gwFzn.useRef)();
    propsRef.current = props;
    return (0, $gwFzn.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("6d7t8"))).FeedbackCollector
});

});
parcelRegister("6d7t8", function(module, exports) {

let $4859c02ad205adbc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4859c02ad205adbc$var$load("bUC6C").then(()=>parcelRequire('cz7bE'));

});



parcelRegister("2bY1t", function(module, exports) {

let $198b2b24243b46d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $198b2b24243b46d6$var$load("zKI0V").then(()=>parcelRequire('6LL3k'));

});



//# sourceMappingURL=EllipsisDropdown.37b688ef.js.map
